// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.externaltour.TourConfirmationType

export enum TourConfirmationType {
  INSTANT = 'INSTANT',
  LANDLORD_CONFIRM = 'LANDLORD_CONFIRM',
}

export const TourConfirmationType_values = [
  TourConfirmationType.INSTANT,
  TourConfirmationType.LANDLORD_CONFIRM,
] as const;
